import React from "react"


interface OwnProps {
  closesAt: string;
  day: string;
  opensAt: string;
}

export type CenterHoursDayProps = OwnProps

export const CenterHoursDay: React.FC<CenterHoursDayProps> = ({
  closesAt,
  day,
  opensAt
}) => {
  return (
    <div className="flex gap-2 md:gap-6" >
      <span className="basis-1/2 capitalize">{day}</span>
      <span className="basis-1/2 whitespace-nowrap">{opensAt && opensAt !== "Closed" ? `${opensAt} - ${closesAt}`: "Closed" }</span>
    </div>
  )
}
